import Vue from 'vue'
import moment from 'moment'

Vue.mixin({
    data: () => {
        return { loader: false }
    },
    methods: {
        toggleLoader() {
            this.loader = this.loader ? false : true;
        },

        moment(...atr) {
            return moment(...atr)
        }
    }
});



// WEBPACK FOOTER //
// ./src/components/mixins/loader.js